import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { css } from '../lib/css'
import { useReveal } from '../lib/reveal'
import { useAnalytics } from '../lib/analytics'
import { noCloseBand } from '../lib/nav'
import { LangProvider, langFromPath, barePath } from '../i18n'
import Header from './Header'
import Footer from './Footer'
import CloseBand from './CloseBand'

export default function Layout() {
  const { pathname } = useLocation()
  useReveal()
  useAnalytics()

  // Scroll to top on navigation (mirrors the original `go()`).
  useEffect(() => {
    if (typeof window !== 'undefined') window.scrollTo({ top: 0, behavior: 'auto' })
  }, [pathname])

  const lang = langFromPath(pathname)
  const bare = barePath(pathname)
  const showClose = !noCloseBand.includes(bare) && !bare.startsWith('/team/')

  return (
    <LangProvider value={lang}>
      <div
        style={css(
          `font-family: Archivo, Helvetica, sans-serif; background: #eaf8fa; color: #16233c; width: 100%; overflow-x: hidden`,
        )}
      >
        <Header />
        <Outlet />
        {showClose && <CloseBand />}
        <Footer />
      </div>
    </LangProvider>
  )
}
